// Port of api/fuel/app/classes/insights/game/plays.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'plays',
    priority: 8,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.has_plays) return {}

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)
        var playsRaw = this._data.plays_raw
        var totalPlays = this._data.totalPlays

        var data = {
            byYear: [],
            byMonth: [],
            byDayOfWeek: [0, 0, 0, 0, 0, 0, 0],
            longestStreak: 0,
            currentStreak: 0,
            cumulative: [],
            locations: [],
            avgLengthTrend: [],
            velocity: { perMonth: 0, firstHalf: 0, secondHalf: 0 },
            honeymoon: { first: 0, firstRate: 0, rest: 0, restRate: 0, firstMonths: 0, restMonths: 0 },
            seasonality: [],
            sessionDepth: 0,
            completionRate: 0,
            counts: {},
            duration: {},
            current: null,
            longestPlayed: null,
            longestUnplayed: null,
            totalPlayed: 0,
            totalMonths: 0,
            averageHot: 0,
            timeline: [],
            streaks: [],
            streaksTotal: 0
        }

        var byYear = {}
        var byMonth = {}
        var seasonality = {}
        for (var sm = 1; sm <= 12; sm++) seasonality[sm] = 0
        var cumulative = []
        var runningTotal = 0
        var playDates = {}
        var totalLength = 0
        var lengthSessions = 0
        var totalCount = 0
        var totalSessions = 0

        var now = Util.time()
        var cutoff24 = now - (Constants.TIME_MONTH * 24)

        var monthNames = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        for (var i = 0; i < playsRaw.length; i++) {
            var play = playsRaw[i]
            var count = parseInt(play.play_count, 10) || 0
            var date = parseInt(play.play_date, 10) || 0
            var length = parseInt(play.play_length, 10) || 0

            if (date > 0) {
                var year = Util.date('Y', date)
                if (!byYear[year]) byYear[year] = 0
                byYear[year] += count

                if (date >= cutoff24) {
                    var monthKey = Util.date('Y-m', date)
                    if (!byMonth[monthKey]) byMonth[monthKey] = 0
                    byMonth[monthKey] += count
                }

                var dow = parseInt(Util.date('w', date), 10)
                data.byDayOfWeek[dow] += count

                var calMonth = parseInt(Util.date('c', date), 10)
                seasonality[calMonth] += count

                runningTotal += count
                cumulative.push({ date: date, total: runningTotal })

                var dayKey = Util.date('Y-m-d', date)
                if (!playDates[dayKey]) playDates[dayKey] = true
            }

            if (length > 0) {
                totalLength += length
                lengthSessions++
            }

            totalCount += count
            totalSessions++
        }

        // Convert to arrays
        var byYearArr = []
        var yearKeys = Object.keys(byYear).sort()
        for (var yi = 0; yi < yearKeys.length; yi++) {
            byYearArr.push({ year: yearKeys[yi], plays: byYear[yearKeys[yi]] })
        }
        data.byYear = byYearArr

        var byMonthArr = []
        var monthKeys = Object.keys(byMonth).sort()
        for (var mi = 0; mi < monthKeys.length; mi++) {
            byMonthArr.push({ label: monthKeys[mi], plays: byMonth[monthKeys[mi]] })
        }
        data.byMonth = byMonthArr

        var cumulativeArr = []
        for (var ci = 0; ci < cumulative.length; ci++) {
            var cd = new Date(cumulative[ci].date * 1000)
            var cMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            cumulativeArr.push({ label: cMonths[cd.getMonth()] + ' ' + cd.getFullYear(), total: cumulative[ci].total })
        }
        data.cumulative = cumulativeArr

        var dowNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        var byDowArr = []
        for (var di = 0; di < 7; di++) {
            byDowArr.push({ day: dowNames[di], plays: data.byDayOfWeek[di] })
        }
        data.byDayOfWeek = byDowArr

        var seasonArr = []
        for (var si = 1; si <= 12; si++) {
            seasonArr.push({ month: monthNames[si], plays: seasonality[si] })
        }
        data.seasonality = seasonArr

        // Hot & cold streaks
        if (playsRaw.length > 0) {
            var playMonths = {}
            for (var pm = 0; pm < playsRaw.length; pm++) {
                var pdate = parseInt(playsRaw[pm].play_date, 10) || 0
                if (pdate > 0) playMonths[Util.date('Y-m', pdate)] = true
            }

            var pmKeys = Object.keys(playMonths)
            if (pmKeys.length) {
                pmKeys.sort()
                var firstMonth = pmKeys[0]
                var nowMonth = Util.date('Y-m', now)

                var cursor = firstMonth
                var streaks = []
                var streakStart = firstMonth
                var streakLen = 0
                var streakType = null

                while (cursor <= nowMonth) {
                    var hasPlay = !!playMonths[cursor]
                    var sType = hasPlay ? 'played' : 'unplayed'

                    if (sType === streakType) {
                        streakLen++
                    } else {
                        if (streakType !== null) {
                            streaks.push({ type: streakType, months: streakLen, from: streakStart, to: cursor })
                        }
                        streakType = sType
                        streakStart = cursor
                        streakLen = 1
                    }

                    var parts = cursor.split('-')
                    var cy = parseInt(parts[0], 10)
                    var cm = parseInt(parts[1], 10) + 1
                    if (cm > 12) { cm = 1; cy++ }
                    cursor = ('0000' + cy).slice(-4) + '-' + ('0' + cm).slice(-2)
                }

                if (streakType !== null) {
                    streaks.push({ type: streakType, months: streakLen, from: streakStart, to: cursor })
                }

                var timeline = []
                var totalStreakMonths = 0
                var totalPlayedMonths = 0
                var playedStreakLengths = []

                for (var ti = 0; ti < streaks.length; ti++) {
                    timeline.push({ type: streaks[ti].type, months: streaks[ti].months })
                    totalStreakMonths += streaks[ti].months
                    if (streaks[ti].type === 'played') {
                        totalPlayedMonths += streaks[ti].months
                        playedStreakLengths.push(streaks[ti].months)
                    }
                }

                data.timeline = timeline
                var firstParts = firstMonth.split('-')
                data.timelineStart = monthNames[parseInt(firstParts[1], 10)] + ' ' + firstParts[0]
                data.totalPlayed = totalPlayedMonths
                data.totalMonths = totalStreakMonths
                data.averageHot = playedStreakLengths.length ? Math.round(playedStreakLengths.reduce(function(a, b) { return a + b }, 0) / playedStreakLengths.length * 10) / 10 : 0

                var current = streaks[streaks.length - 1] || null
                var longestPlayed = null
                var longestUnplayed = null

                for (var ls = 0; ls < streaks.length; ls++) {
                    if (streaks[ls].type === 'played' && (longestPlayed === null || streaks[ls].months > longestPlayed.months)) longestPlayed = streaks[ls]
                    if (streaks[ls].type === 'unplayed' && (longestUnplayed === null || streaks[ls].months > longestUnplayed.months)) longestUnplayed = streaks[ls]
                }

                var formatStreak = function(s) {
                    if (!s) return null
                    var fp = s.from.split('-')
                    var fromLabel = monthNames[parseInt(fp[1], 10)] + ' ' + fp[0]
                    var tp = s.to.split('-')
                    var ty = parseInt(tp[0], 10)
                    var tm = parseInt(tp[1], 10) - 1
                    if (tm < 1) { tm = 12; ty-- }
                    var toLabel = monthNames[tm] + ' ' + ty
                    return { type: s.type, months: s.months, fromLabel: fromLabel, toLabel: toLabel }
                }

                data.current = formatStreak(current)
                data.longestPlayed = formatStreak(longestPlayed)
                data.longestUnplayed = formatStreak(longestUnplayed)

                // Format streaks for display
                for (var fs = 0; fs < streaks.length; fs++) {
                    var fp2 = streaks[fs].from.split('-')
                    streaks[fs].fromLabel = monthNames[parseInt(fp2[1], 10)] + ' ' + fp2[0]
                    var tp2 = streaks[fs].to.split('-')
                    var ty2 = parseInt(tp2[0], 10)
                    var tm2 = parseInt(tp2[1], 10) - 1
                    if (tm2 < 1) { tm2 = 12; ty2-- }
                    streaks[fs].toLabel = monthNames[tm2] + ' ' + ty2
                    delete streaks[fs].from
                    delete streaks[fs].to
                }

                streaks.sort(function(a, b) { return b.months - a.months })
                data.streaksTotal = streaks.length
                data.streaks = streaks.slice(0, 5)

                // Share streak data with Streaks detail segment
                this._data.computed_streaks = {
                    current: data.current,
                    longestPlayed: data.longestPlayed,
                    longestUnplayed: data.longestUnplayed,
                    totalPlayed: data.totalPlayed,
                    totalMonths: data.totalMonths,
                    averageHot: data.averageHot,
                    timeline: data.timeline,
                    streaks: streaks
                }
            }
        }

        // Session depth
        if (totalSessions > 0) {
            data.sessionDepth = Math.round(totalCount / totalSessions * 100) / 100
        }

        // Day streak detection
        var sortedDays = Object.keys(playDates).sort()
        if (sortedDays.length > 0) {
            var longest = 1
            var streak2 = 1

            for (var sd = 1; sd < sortedDays.length; sd++) {
                var prev = new Date(sortedDays[sd - 1]).getTime() / 1000
                var curr = new Date(sortedDays[sd]).getTime() / 1000
                var diff = (curr - prev) / Constants.TIME_DAY

                if (diff === 1) {
                    streak2++
                } else {
                    if (streak2 > longest) longest = streak2
                    streak2 = 1
                }
            }
            if (streak2 > longest) longest = streak2

            var today = Util.date('Y-m-d', now)
            var yesterday = Util.date('Y-m-d', now - Constants.TIME_DAY)
            var lastDay = sortedDays[sortedDays.length - 1]
            var currentStreak = 0

            if (lastDay === today || lastDay === yesterday) {
                currentStreak = 1
                for (var cs = sortedDays.length - 2; cs >= 0; cs--) {
                    var c2 = new Date(sortedDays[cs + 1]).getTime() / 1000
                    var p2 = new Date(sortedDays[cs]).getTime() / 1000
                    if ((c2 - p2) / Constants.TIME_DAY === 1) {
                        currentStreak++
                    } else {
                        break
                    }
                }
            }

            data.longestStreak = longest
            data.currentStreak = currentStreak
        }

        // Avg play length trend by year
        if (lengthSessions > 0) {
            var lengthByYear = {}
            var countByYear = {}

            for (var ly = 0; ly < playsRaw.length; ly++) {
                var ll = parseInt(playsRaw[ly].play_length, 10) || 0
                var ld = parseInt(playsRaw[ly].play_date, 10) || 0
                if (ll > 0 && ld > 0) {
                    var lYear = Util.date('Y', ld)
                    if (!lengthByYear[lYear]) { lengthByYear[lYear] = 0; countByYear[lYear] = 0 }
                    lengthByYear[lYear] += ll
                    countByYear[lYear]++
                }
            }

            var avgLengthTrend = []
            var lyKeys = Object.keys(lengthByYear).sort()
            for (var lk = 0; lk < lyKeys.length; lk++) {
                avgLengthTrend.push({ year: lyKeys[lk], avg: Math.round(lengthByYear[lyKeys[lk]] / countByYear[lyKeys[lk]]) })
            }
            data.avgLengthTrend = avgLengthTrend
        }

        // Find first and last dated plays
        var firstDate = 0
        var lastDate = 0
        for (var fd = 0; fd < playsRaw.length; fd++) {
            var dd = parseInt(playsRaw[fd].play_date, 10) || 0
            if (dd > 0) {
                if (firstDate === 0) firstDate = dd
                lastDate = dd
            }
        }

        // Play velocity
        if (firstDate > 0) {
            if (lastDate > firstDate) {
                var vMonthSpan = Math.max(1, Math.round((lastDate - firstDate) / Constants.TIME_MONTH))
                data.velocity.perMonth = Math.round(totalPlays / vMonthSpan * 100) / 100

                var midpoint = firstDate + ((lastDate - firstDate) / 2)
                var firstHalf = 0
                var secondHalf = 0

                for (var vh = 0; vh < playsRaw.length; vh++) {
                    if ((parseInt(playsRaw[vh].play_date, 10) || 0) <= midpoint) {
                        firstHalf += parseInt(playsRaw[vh].play_count, 10) || 0
                    } else {
                        secondHalf += parseInt(playsRaw[vh].play_count, 10) || 0
                    }
                }

                data.velocity.firstHalf = firstHalf
                data.velocity.secondHalf = secondHalf
            } else {
                data.velocity.perMonth = totalPlays
                data.velocity.firstHalf = totalPlays
                data.velocity.secondHalf = 0
            }
        }

        // Honeymoon effect
        if (playsRaw.length > 0 && firstDate > 0) {
            var honeymoonEnd = firstDate + (Constants.TIME_MONTH * 3)
            var firstCount = 0
            var restCount = 0

            for (var hm = 0; hm < playsRaw.length; hm++) {
                var hd = parseInt(playsRaw[hm].play_date, 10) || 0
                var hc = parseInt(playsRaw[hm].play_count, 10) || 0
                if (hd > 0 && hd <= honeymoonEnd) firstCount += hc
                else if (hd > 0) restCount += hc
            }

            var totalMonthSpan = Math.max(1, Math.round((lastDate - firstDate) / Constants.TIME_MONTH))

            if (totalMonthSpan > 3) {
                var restMonths = totalMonthSpan - 3
                data.honeymoon = { first: firstCount, firstRate: Math.round(firstCount / 3 * 10) / 10, rest: restCount, restRate: Math.round(restCount / restMonths * 10) / 10, firstMonths: 3, restMonths: restMonths }
            } else {
                var honeymoonMonths = Math.max(1, totalMonthSpan)
                data.honeymoon = { first: firstCount, firstRate: Math.round(firstCount / honeymoonMonths * 10) / 10, rest: restCount, restRate: 0, firstMonths: honeymoonMonths, restMonths: 0 }
            }
        }

        // Player count distribution
        var counts = {}
        for (var pc = 0; pc < playsRaw.length; pc++) {
            var players = parseInt(playsRaw[pc].play_players, 10) || 0
            if (players > 0) {
                if (!counts[players]) counts[players] = 0
                counts[players] += parseInt(playsRaw[pc].play_count, 10) || 0
            }
        }
        data.counts = counts

        // Duration distribution (10-minute buckets)
        var durationMap = {}
        for (var dr = 0; dr < playsRaw.length; dr++) {
            var dl = parseInt(playsRaw[dr].play_length, 10) || 0
            if (dl > 0) {
                var bucket = Math.max(1, Math.ceil(dl / 10))
                if (!durationMap[bucket]) durationMap[bucket] = 0
                durationMap[bucket]++
            }
        }
        data.duration = durationMap

        // Locations
        var locationsRaw = Util.queryFast(
            'SELECT LOWER(TRIM(p.play_location)) AS name, SUM(p.play_count) AS count ' +
            'FROM play p WHERE p.user_id = ' + user_id + ' AND p.game_id = ' + game_id +
            ' AND p.play_location <> "" GROUP BY LOWER(TRIM(p.play_location))'
        )

        var locations = Util.sort_by_field(locationsRaw, 'count', 'desc')
        data.locationsTotal = locations.length
        data.locations = locations.slice(0, 5)

        // Completion rate
        var incompleteCount = 0
        for (var ic = 0; ic < playsRaw.length; ic++) {
            if (parseInt(playsRaw[ic].play_incomplete, 10) === 1) incompleteCount++
        }
        data.completionRate = (totalSessions > 0) ? Math.round((100 - ((100 / totalSessions) * incompleteCount)) * 10) / 10 : 0

        return {
            plays: data
        }

    }
})
